import Vue from 'vue';
import appconst from './appConst';
import ProductCategory from '@/store/entities/baseInfo/ProductCategory';

class Util {
    abp: any = window.abp;
    tenant: any;
    transactionType: number = 0;

    constructor() {
        this.tenant = this.abp.multiTenancy.getTenantCookie();

        if (this.tenant) {
            this.transactionType = this.tenant.transactionType;
        }
    }

    /**
     * Is development environment.
    */
    isDevelopment = function () {
        return process.env.NODE_ENV === 'development';
    }

    loadScript(url: string) {
        var script = document.createElement('script');
        script.type = "text/javascript";
        script.src = url;
        document.body.appendChild(script);
    }
    title(title: string) {
        if (!this.tenant) {
            console.error('tenant not specified')
            return;
        }
        const tanantName = this.tenant.name;
        // let appname = this.abp.localization.localize('ThisAppName', appconst.localization.defaultLocalizationSourceName);
        // let personalCenter = this.abp.localization.localize('PersonalCenter', appconst.localization.defaultLocalizationSourceName);
        const page = this.L(title);

        if (title === 'HomePage') {
            window.document.title = tanantName;
        } else {
            window.document.title = page + ' - ' + tanantName;
        }
    }
    inOf(arr: Array<any>, targetArr: any) {
        let res = true;
        arr.forEach(item => {
            if (targetArr.indexOf(item) < 0) {
                res = false;
            }
        });
        return res;
    }
    oneOf(ele: any, targetArr: Array<any>) {
        if (targetArr.indexOf(ele) >= 0) {
            return true;
        } else {
            return false;
        }
    }
    showThisRoute(itAccess: any, currentAccess: any) {
        if (typeof itAccess === 'object' && Array.isArray(itAccess)) {
            return this.oneOf(currentAccess, itAccess);
        } else {
            return itAccess === currentAccess;
        }
    }
    getRouterObjByName(routers: Array<any>, name?: string): any {
        if (!name || !routers || !routers.length) {
            return null;
        }
        // debugger;
        let routerObj = null;
        for (let item of routers) {
            if (item.name === name) {
                return item;
            }
            routerObj = this.getRouterObjByName(item.children, name);
            if (routerObj) {
                return routerObj;
            }
        }
        return null;
    }
    toDefaultPage(routers: Array<any>, name: string | undefined, route: any, next: any) {
        let len = routers.length;
        let i = 0;
        let notHandle = true;
        while (i < len) {
            if (routers[i].name === name && routers[i].children && routers[i].redirect === undefined) {
                route.replace({
                    name: routers[i].children[0].name
                });
                notHandle = false;
                next();
                break;
            }
            i++;
        }
        if (notHandle) {
            next();
        }
    }
    handleTitle(vm: any, item: any) {
        if (typeof item.meta.title === 'object') {
            return vm.$t(item.title.i18n);
        } else {
            return item.meta.title;
        }
    }
    setCurrentPath(vm: Vue, name?: string) {
        let title = '';
        let isOtherRouter = false;
        vm.$store.state.app.routers.forEach((item: any) => {
            if (item.children.length === 1) {
                if (item.children[0].name === name) {
                    title = this.handleTitle(vm, item);
                    if (item.name === 'otherRouter') {
                        isOtherRouter = true;
                    }
                }
            } else {
                item.children.forEach((child: any) => {
                    if (child.name === name) {
                        title = this.handleTitle(vm, child);
                        if (item.name === 'otherRouter') {
                            isOtherRouter = true;
                        }
                    }
                });
            }
        });
        let currentPathArr = [];
        if (name === 'home') {
            currentPathArr = [
                {
                    meta: { title: this.handleTitle(vm, this.getRouterObjByName(vm.$store.state.app.routers, 'home')) },
                    path: 'pc/home',
                    name: 'home'
                }
            ];
        } else if (((name as string).indexOf('index') >= 0 || isOtherRouter) && name !== 'home') {
            currentPathArr = [
                {
                    meta: { title: this.handleTitle(vm, this.getRouterObjByName(vm.$store.state.app.routers, 'home')) },
                    path: 'pc/home',
                    name: 'home'
                },
                {
                    meta: { title: title },
                    path: '',
                    name: name
                }
            ];
        } else {
            let currentPathObj = vm.$store.state.app.routers.filter((item: any) => {
                if (item.children.length <= 1) {
                    return item.children[0].name === name || item.name === name;
                } else {
                    let i = 0;
                    let childArr = item.children;
                    let len = childArr.length;
                    while (i < len) {
                        if (childArr[i].name === name) {
                            return true;
                        }
                        i++;
                    }
                    return false;
                }
            })[0];
            if (currentPathObj.children && currentPathObj.children.length <= 1 && currentPathObj.name === 'home') {
                currentPathArr = [
                    {
                        meta: { title: 'PersonalCenterHomePage' },
                        path: 'pc/home',
                        name: 'home'
                    }
                ];
            } else if (currentPathObj.children && currentPathObj.children.length <= 1 && currentPathObj.name !== 'home') {
                currentPathArr = [
                    {
                        meta: { title: 'PersonalCenterHomePage' },
                        path: 'pc/home',
                        name: 'home'
                    },
                    {
                        meta: { title: currentPathObj.meta.title },
                        path: '',
                        name: name
                    }
                ];
            } else {
                let childObj = currentPathObj.children.filter((child: any) => {
                    return child.name === name;
                })[0];
                currentPathArr = [
                    {
                        meta: { title: 'PersonalCenterHomePage' },
                        path: 'pc/home',
                        name: 'home'
                    },
                    {
                        meta: { title: currentPathObj.meta.title },
                        path: '',
                        name: ''
                    },
                    {
                        meta: { title: childObj.meta.title },
                        path: currentPathObj.path + '/' + childObj.path,
                        name: name
                    }
                ];
            }
        }
        vm.$store.commit('app/setCurrentPath', currentPathArr);

        return currentPathArr;
    }
    openNewPage(vm: Vue, name: string | undefined, argu?: any, query?: any) {
        let pageOpenedList = vm.$store.state.app.pageOpenedList;
        let openedPageLen = pageOpenedList.length;
        let i = 0;
        let tagHasOpened = false;
        while (i < openedPageLen) {
            if (name === pageOpenedList[i].name) { // 页面已经打开
                vm.$store.commit('app/pageOpenedList', {
                    index: i,
                    argu: argu,
                    query: query
                });
                tagHasOpened = true;
                break;
            }
            i++;
        }
        // if (!tagHasOpened) {
        //     let tag = vm.$store.state.app.tagsList.filter((item:any) => {
        //         if (item.children) {
        //             return name === item.children[0].name;
        //         } else {
        //             return name === item.name;
        //         }
        //     });
        //     tag = tag[0];
        //     if (tag) {
        //         tag = tag.children ? tag.children[0] : tag;
        //         if (argu) {
        //             tag.argu = argu;
        //         }
        //         if (query) {
        //             tag.query = query;
        //         }
        //         vm.$store.commit('app/increateTag', tag);
        //     }
        // }
        vm.$store.commit('app/setCurrentPageName', name);
    }
    fullscreenEvent(vm: Vue) {
        vm.$store.commit('app/initCachepage');
        // 权限菜单过滤相关
        vm.$store.commit('app/updateMenulist');
        // 全屏相关
    }

    L(value: string, source?: string, ...argus: string[]): string {
        let text = value;

        if (source) {
            text = window.abp.localization.localize(value, source, argus);
        } else {
            text = window.abp.localization.localize(value, appconst.localization.defaultLocalizationSourceName, argus);
        }

        if (value && value.indexOf('Product') !== -1) {
            if (this.transactionType === 0) {
                text = text.replace('产品', '作品')
            } else if (this.transactionType === 1) {
                text = text.replace('产品', '商品')
            } else if (this.transactionType === 2) {
                text = text.replace('产品', '服务')
            }
        }

        if (value && value.indexOf('AwaitTakingDelivery') !== -1) {
            if (this.transactionType === 2) {
                text = '待服务'
            }
        }

        return text;
    }
    LShop(value: string, ...argus: string[]): string {
        return window.abp.localization.localize(value, appconst.localization.shopLocalizationSourceName, argus);
    }
    validateImageFile(file: File) {
        var allowedImage = JSON.parse(process.env.VUE_APP_FDM_ALLOWED).image;
        var dto = { result: false, msg: this.L("UnknowError") };

        for (var img in allowedImage.types) {
            if (file.type.indexOf(allowedImage.types[img]) > -1) {
                dto.result = true;
            }
        }

        if (!dto.result) {
            dto.msg = this.L("FileTypeNotAllowed", file.name);
        }

        if (file.size / 1000 > allowedImage.size) {
            dto.result = false;
            dto.msg = this.L("FileSizeExceeded", file.name);
        }

        return dto;
    }

    extend(...args: any[]) {
        let options, name, src, srcType, copy, copyType, copyIsArray, clone,
            target = args[0] || {},
            i = 1,
            length = args.length,
            deep = false;
        if (typeof target === 'boolean') {
            deep = target;
            target = args[i] || {};
            i++;
        }
        if (typeof target !== 'object' && typeof target !== 'function') {
            target = {};
        }
        if (i === length) {
            target = this;
            i--;
        }
        for (; i < length; i++) {
            if ((options = args[i]) !== null) {
                for (name in options) {
                    src = target[name];
                    copy = options[name];
                    if (target === copy) {
                        continue;
                    }
                    srcType = Array.isArray(src) ? 'array' : typeof src;
                    if (deep && copy && ((copyIsArray = Array.isArray(copy)) || typeof copy === 'object')) {
                        if (copyIsArray) {
                            copyIsArray = false;
                            clone = src && srcType === 'array' ? src : [];
                        } else {
                            clone = src && srcType === 'object' ? src : {};
                        }
                        target[name] = this.extend(deep, clone, copy);
                    } else if (copy !== undefined) {
                        target[name] = copy;
                    }
                }
            }
        }
        return target;
    }

    refresh(vm: Vue) {
        vm.$router.replace({
            path: '/refresh'
        });
    }

    relogin(vm: Vue) {
        vm.$Modal.error({
            title: window.abp.localization.localize("SystemTips", appconst.localization.defaultLocalizationSourceName),
            content: window.abp.localization.localize("SessionTimeout", appconst.localization.defaultLocalizationSourceName),
            onOk: () => {
                localStorage.setItem('LoginReturnUrl', window.location.href);
                location = appconst.authorization.homeUri;
            }
        });
    }

    formatDate = (date: Date, formatStr: String): string => {
        if (!date) {
            date = new Date();
        }
        let str = formatStr;
        let month = date.getMonth() + 1;
        let milliseconds = date.getMilliseconds();
        let Week = ['日', '一', '二', '三', '四', '五', '六'];

        str = str.replace(/yyyy|YYYY/, date.getFullYear().toString());
        str = str.replace(/yy|YY/, (date.getFullYear() % 100) > 9 ? (date.getFullYear() % 100).toString() : '0' + (date.getFullYear() % 100));

        str = str.replace(/MM/, month > 9 ? month.toString() : '0' + month);
        str = str.replace(/M/g, month.toString());

        str = str.replace(/w|W/g, Week[date.getDay()]);

        str = str.replace(/dd|DD/, date.getDate() > 9 ? date.getDate().toString() : '0' + date.getDate());
        str = str.replace(/d|D/g, date.getDate().toString());

        str = str.replace(/hh|HH/, date.getHours() > 9 ? date.getHours().toString() : '0' + date.getHours());
        str = str.replace(/h|H/g, date.getHours().toString());
        str = str.replace(/mm/, date.getMinutes() > 9 ? date.getMinutes().toString() : '0' + date.getMinutes());
        str = str.replace(/m/g, date.getMinutes().toString());

        str = str.replace(/ss|SS/, date.getSeconds() > 9 ? date.getSeconds().toString() : '0' + date.getSeconds());
        str = str.replace(/s|S/g, date.getSeconds().toString());

        str = str.replace(/ffff|FFFF/, milliseconds >= 100 ? '0' + milliseconds : '00' + milliseconds);
        str = str.replace(/ff|FF/, milliseconds > 99 ? milliseconds.toString().substring(0, 2) : milliseconds.toString());

        return str.toString();
    }

    getCategory(categoryNo: string) {
        let categories = JSON.parse(localStorage.getItem('categories'));
        let category = new ProductCategory();

        // find current category
        categories.forEach(x => {
            if (x.productCategoryNo === categoryNo) {
                category = x;
                return;
            }
            if (x.children.length > 0) {
                x.children.forEach(y => {
                    if (y.productCategoryNo === categoryNo) {
                        category = y;
                        return;
                    }
                });
            }
        });

        // find parent category
        categories.forEach(x => {
            if (x.id == category.parentId) {
                category["parentCategory"] = x;
            }
        });

        return category;
    }

    isLeapYear(year) {
        return (((year % 4 === 0) && (year % 100 !== 0)) || (year % 400 === 0));
    }

    getDaysInMonth(year, month) {
        return [31, (this.isLeapYear(year) ? 29 : 28), 31, 30, 31, 30, 31, 31, 30, 31, 30, 31][month];
    }

    addMonths(date, value) {
        let n = date.getDate();
        date.setDate(1);
        date.setMonth(date.getMonth() + value);
        date.setDate(Math.min(n, this.getDaysInMonth(date.getFullYear(), date.getMonth())));
        return date;
    }

    changePageIndex(vm: Vue, page: number) {
        vm.$route.query["p"] = page.toString();
        let url = vm.$route.path + "?p=" + page;

        Object.keys(vm.$route.query).forEach(qi => {
            if (qi.toLowerCase() === "p") {
                return;
            }
            url += "&" + qi + "=" + vm.$route.query[qi];
        });

        window.open(url, "_self");
    }

    setCurrentPageIndex(vm: Vue) {
        if (vm.$route.query && vm.$route.query.p) {
            vm.$store.commit('product/setCurrentPage', parseInt(vm.$route.query.p.toString()));
        }
    }

    /**
     * Get the tenancy name from domain.
    */
    getTenancyNameFromDomain = () => {
        let domain = this.abp.utils.getDomain(location.href);
        let domainSegment = domain.split('.')[0];
        let tenancyName = domainSegment.split('-')[0];
        return tenancyName;
    }

    /**
     * Get the tenancy name from url parameter or cookie.
    */
    getTenancyName = () => {
        let tenancyName = appconst.tenancyName; //  this.abp.utils.getUrlParameter('tenant')
        const domain = this.abp.utils.getDomain(location.href);
        const domainItems = domain.split('.');


        // 开发环境取URL参数
        if (this.isDevelopment()) {
            tenancyName = this.abp.utils.getUrlParameter('tenant');
        }

        // 例如，http://funcdot.fdm.ink/
        if (domainItems.length === 3 && domainItems[0] !== 'www') {
            tenancyName = domainItems[0];
        }

        // 移动端取URL参数tenant的值
        if (domainItems[0] === 'm') {
            tenancyName = this.abp.utils.getUrlParameter('tenant');
        }

        if (!tenancyName || tenancyName === 'undefined') {
            tenancyName = this.tenant.tenancyName; // this.abp.multiTenancy.getTenancyNameCookie();
        }

        return tenancyName;
    }

    /**
     * 判断是否为标准版
    */
    isStandardEdition = () => {
        return this.getTenancyName().toLowerCase() === 'fdm';
    }

    validateURL = (url) => {
        try {
            // 创建URL对象
            var parsedURL = new URL(url);

            // URL对象构造成功表示URL合法
            return true;
        } catch (error) {
            // URL对象构造失败表示URL不合法
            return false;
        }
    }

    /**
     * 是否为移动端
     * @returns {Boolean}
    */
    isMobileDevice = () => {
        // 常见的移动设备用户代理  
        var mobileUserAgent = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i;

        // 检查用户代理是否包含这些字符串  
        return mobileUserAgent.test(navigator.userAgent);
    }

    /**
     * PC端、移动端识别
    */
    checkDevice = () => {
        let domain = this.abp.utils.getDomain(location.href);
        let domainItems = domain.split('.');
        let firstPart = domainItems[0];
        const isMobile = this.isMobileDevice();

        // 开发环境
        if (location.href.indexOf('localhost') !== -1) {
            return;
        }

        if (firstPart === 'www') {
            domainItems.splice(0, 1);
            firstPart = domainItems[0];
        }

        if (isMobile) {
            if (firstPart === 'wx') {
                return;
            }

            if (firstPart !== 'm') {
                if (domainItems.length === 3) {
                    location.href = `http://m.${domainItems[1]}.${domainItems[2]}/home?tenant=${firstPart}`
                } else {
                    location.href = `http://m.${domainItems[0]}.${domainItems[1]}`
                }
            }
        } else {
            if (firstPart === 'm') {
                location.href = `http://${domainItems[1]}.${domainItems[2]}`
            }
        }
    }

    /**
     * 下载文件
     * @param {fileUrl: string} 文件URL地址
    */
    downloadFile = (fileUrl) => {
        if (!fileUrl) {
            console.error('参数不能为空，名称 fileUrl');
            return;
        }
        const splitItems = fileUrl.split('.');
        const name = splitItems[0];
        const extension = splitItems[splitItems.length - 1];
        console.log(fileUrl)
        // 创建a标签
        const link = document.createElement('a');
        link.href = fileUrl;
        // 设置a标签的href属性为Blob URL
        // link.href = window.URL.createObjectURL(blob);
        // 设置下载的文件名
        link.download = `${name}.${extension}`; // 文件名和扩展名
        // 将a标签添加到body中
        document.body.appendChild(link);
        // 模拟点击事件进行下载
        link.click();
        document.body.removeChild(link);

        // fetch(fileUrl) // 获取图片数据
        //     .then(response => response.blob()) // 将响应转换为Blob对象
        //     .then(blob => {
        //         // 创建a标签
        //         const link = document.createElement('a');
        //         // 设置a标签的href属性为Blob URL
        //         link.href = window.URL.createObjectURL(blob);
        //         // 设置下载的文件名
        //         link.download = `${name}.${extension}`; // 文件名和扩展名
        //         // 将a标签添加到body中
        //         // document.body.appendChild(link);
        //         // 模拟点击事件进行下载
        //         link.click();
        //         // 下载完成后清理资源
        //         // document.body.removeChild(link); // 移除a标签
        //         window.URL.revokeObjectURL(link.href); // 释放Blob URL资源
        //     })
        //     .catch(error => console.error('下载失败:', error)); // 处理错误情况
    }
}

const util = new Util();
export default util;